import React from "react";
import { useTranslation } from "react-i18next";

export interface Props {
  page: number;
  totalPages: number;
  handlePages: (page: number) => void;
  goToNextPage: () => void;
  goToPreviousPage: () => void;
}

export const CustomPagination: React.FC<Props> = ({
  page,
  totalPages,
  goToPreviousPage,
  handlePages,
  goToNextPage,
}) => {
  const { t } = useTranslation();
  return (
    <ul className="pagination justify-content-end me-3 mt-2 mb-0">
      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
        <button className="page-link" onClick={goToPreviousPage}>
          {t("customer.previous")}
        </button>
      </li>
      {Array.from({ length: totalPages }, (_, index) => (
        <li
          key={index}
          className={`page-item ${page === index + 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePages(index + 1)}>
            {index + 1}
          </button>
        </li>
      ))}
      <li className={`page-item ${page >= totalPages || totalPages === 0 ? "disabled" : ""}`}>
        <button className="page-link" onClick={goToNextPage}>
          {t("customer.next")}
        </button>
      </li>
    </ul>
  );
};
